import { render, staticRenderFns } from "./OtherRaisonExplain.vue?vue&type=template&id=c90b0478&"
import script from "./OtherRaisonExplain.vue?vue&type=script&lang=js&"
export * from "./OtherRaisonExplain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports